import { render, staticRenderFns } from "./MensagemSomenteVip.vue?vue&type=template&id=271daa90&"
import script from "./MensagemSomenteVip.vue?vue&type=script&lang=js&"
export * from "./MensagemSomenteVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports